import { render, staticRenderFns } from "./guest-sorts-slidebar.vue?vue&type=template&id=45c50ab2&"
import script from "./guest-sorts-slidebar.vue?vue&type=script&lang=ts&"
export * from "./guest-sorts-slidebar.vue?vue&type=script&lang=ts&"
import style0 from "./guest-sorts-slidebar.vue?vue&type=style&index=0&id=45c50ab2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports